<template>
    <div class="field">
        <div class="field">
            <div class="control has-icons-left">
                <input v-model="manager"
                       v-bind:class="{ 'is-danger': error && error.length > 0 }"
                       class="input"
                       type="text"
                       placeholder="Type Manager"
                       disabled>
                <span class="icon is-left">
                     <i class="fas fa-user-shield"></i>
                </span>
            </div>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            manager: {
                get: function () {
                    return this.$store.getters.getNewCarManagerName
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorManager
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/ManagerSelect.vue